import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Panel } from '@nintex-ux/react-core/dist/Panel';
import { GlobalNav } from '@nintex-ux/react-core/dist/GlobalNav';
import { Button } from '@nintex-ux/react-core/dist/Button';
import '@nintex-ux/icons-svg/icons/utility/chevron-right.svg';
import '@nintex-ux/icons-svg-monochrome/icons/utility/arrow-move-left.svg';
import '../custom.scss';
import qs from 'query-string';
import cn from 'classnames';
import Alert from '@nintex-ux/react-core/dist/Alert/Alert';
import LabelImage from './LabelImage';
import assemblyImage from '../assets/assembly.svg';
import workflowImage from '../assets/workflow.svg';
import formImage from '../assets/form.svg';
import notificationApprovalImage from '../assets/notification-approval.svg';

const ConnectedUserLanding = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState();
    const [nwcRedirectUri, setNwcRedirectUri] = useState('');
    const [sharePointFormsRedirectUri, setSharePointFormsRedirectUri] = useState('');
    const queryString = qs.parse(history.location.search);

    useEffect(() => {
        const getRedirectInfo = async () => {
            try {
                const getRedirectInfoUrl = `/GetRedirectInfo/${queryString.spTenantId}/${queryString.uniqueId}`;
                const response = await fetch(getRedirectInfoUrl);
                if (!response.ok) {
                    setErrorMessage(t('genericError'));
                }
                const data = await response.json();
                setNwcRedirectUri(data.nwcRedirectUri);
                setSharePointFormsRedirectUri(data.sharePointFormsRedirectUri);
            } catch (error) {
                setErrorMessage(t('genericError'));
            }
        };
        getRedirectInfo();
    }, []);

    const listUrl = () => {
        return queryString.listUri;
    };

    const navigateToNwc = () => {
        if (nwcRedirectUri) {
            window.open(nwcRedirectUri, '_self');
            return;
        }
    };

    const navigateToFormDesigner = () => {
        window.location.href = sharePointFormsRedirectUri;
    };

    const redirectToSharePointList = () => {
        window.location.href = listUrl();
    };

    return (
        <>
            <GlobalNav />
            <div className={cn('nwc-container container-fluid')}>
                <div className="nx-page-header">
                    <div className="nx-page-header-title">{t('connectedUserLanding.title')}</div>
                    <hr></hr>
                </div>
                <Panel title={t('nintexAutomationCloud')}>
                    <Panel.Content>
                        <>
                            <div>
                               {t('connectedUserLanding.description')} 
                            </div>
                            <div className="nx-custom-panel-image-container">
                                <LabelImage
                                    image={workflowImage}
                                    title={t('connectedUserLanding.workflows')}
                                    alt={t('nintexAutomationCloud')}
                                ></LabelImage>
                                <LabelImage
                                    image={formImage}
                                    alt={t('connectedUserLanding.formsAltText')}
                                    title={t('connectedUserLanding.forms')}
                                ></LabelImage>
                                <LabelImage
                                    image={assemblyImage}
                                    title={t('connectedUserLanding.dataIntegration')}
                                    alt={t('connectedUserLanding.dataIntegrationAltText')}
                                ></LabelImage>
                                <LabelImage
                                    image={notificationApprovalImage}
                                    title={t('connectedUserLanding.processTracking')}
                                    alt={t('connectedUserLanding.processTrackingAltText')}
                                ></LabelImage>
                            </div>

                            <hr></hr>
                            <div className="nx-nwc-launch-button-container">
                                <div>
                                    <Button
                                        data-test-id="btnCreateWithNWC"
                                        onClick={() => navigateToNwc()}
                                    >
                                       {t('connectedUserLanding.createWithNac')} 
                                    </Button>
                                </div>
                            </div>
                        </>
                    </Panel.Content>
                </Panel>
                <div className={cn('nx-form-designer-panel')}>
                    {errorMessage && (
                        <Alert type="danger" className="nx-form-designer-error">
                            <p>{errorMessage}</p>
                        </Alert>
                    )}
                    <Panel title="">
                        <Panel.Header>
                            <div className="nx-header-custom-wrapper">
                                <h3 className="nx-panel-heading">
                                    {t('connectedUserLanding.sharePointListFormDesigner')}
                                </h3>
                                <span className="nx-panel-right-title">{t('connectedUserLanding.poweredBy')}</span>
                            </div>
                        </Panel.Header>
                        <Panel.Content>
                            <div className="nx-panel-content-wrapper">
                                <div>
                                    <span>
                                       {t('connectedUserLanding.customizeFormLookAndFeel')} 
                                    </span>
                                </div>
                                <Button
                                    type="secondary"
                                    className="nx-panel-content-button"
                                    onClick={() => navigateToFormDesigner()}
                                >
                                    {t('connectedUserLanding.customizeForm')} 
                                </Button>
                            </div>
                        </Panel.Content>
                    </Panel>
                </div>
                <Button
                    icon="arrow-move-left"
                    type="link"
                    link={true}
                    onClick={redirectToSharePointList}
                >
                    {t('returnToSharePoint')}
                </Button>
            </div>
        </>
    );
};

export default ConnectedUserLanding;
